// Stat Box

import { Box, Typography } from '@mui/material';
import type { FC } from 'react';

interface Props {
  title: string;
  value: string;
}

const ReportsTemplateStatBox: FC<Props> = ({ title, value }) => {
  const testId = title.split(' ').join('-').toLowerCase();
  return (
    <Box
      data-testid={`${testId}`}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        justifyContent: 'space-between',
        height: '100%'
      }}
    >
      {/* Title */}
      <Typography
        variant="h6"
        sx={{
          color: '#1C4A50',
          fontWeight: 600,
          paddingBottom: 1.5,
          fontSize: 13
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'left',
          alignItems: 'center'
        }}
      >
        <Typography variant="h3" sx={{ fontWeight: 500 }}>
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

export default ReportsTemplateStatBox;
